import { giphyDarkestGrey } from '@giphy/js-brand'
import { useContext } from 'react'
import { UgeLayersContext } from '../../contexts/layers'
import { Layer } from '../../types'
import { layerActionIcon, layerActionShortName, ugeLayerActions } from '../../types/layer-action'
import { Button } from './style'

type Props = {
    disabled?: boolean
    layer: Layer
}

const UgeLayerOptionsButtons = ({ disabled = false, layer }: Props) => {
    const { layers, performLayerAction } = useContext(UgeLayersContext)
    const isLastItem = layers.findIndex(({ id }) => id === layer.id) === 0

    return (
        <>
            {ugeLayerActions.map((action) => {
                const Icon = layerActionIcon(action)
                const isSendToBack = action === 'send-to-back'

                return (
                    <Button
                        color={giphyDarkestGrey}
                        disabled={disabled || (isSendToBack && isLastItem)}
                        key={`layer-actions-${action}`}
                        icon={<Icon />}
                        iconLocation="left"
                        size="small"
                        onClick={() => performLayerAction(layer, action)}
                    >
                        {layerActionShortName(action)}
                    </Button>
                )
            })}
        </>
    )
}

export default UgeLayerOptionsButtons
